import { useTranslation } from 'react-i18next';
import { AcademicOffer } from '../types';
import { Select } from '@octano/global-ui';

interface PeriodSelectorSectionProps {
  periods: AcademicOffer[];
  onPeriodChange: (data: { label: string; value: number }) => void;
  disabled?: boolean;
}

export default function PeriodSelectorSection({
  periods,
  onPeriodChange,
  disabled = false,
}: PeriodSelectorSectionProps) {
  const { t } = useTranslation('configuration/enrollment-and-tuition');

  const periodOptions = periods.map((period) => ({
    label: period.periodName,
    value: period.id,
  }));

  return (
    <Select
      name="selectedPeriod"
      label={t('periodSelector.selectAcademicOffer')}
      options={periodOptions}
      onChange={(option) => {
        onPeriodChange(option);
      }}
      disabled={disabled}
      isClearable={false}
      isSearchable={false}
      placeholder={t('periodSelector.selectAcademicOffer')}
    />
  );
}
